import { Button, Logotype } from '@sortlist-frontend/design-system';
import { useTranslation } from '@sortlist-frontend/translation/ssr';

import { DomainInfo } from '_backend/integration/domain-info';
import { NavigationData } from '_components/layout/Layout';
import { getResourcesMenuData, getUrlHelper } from '_components/layout/PrimaryNav/DesktopNav/utils';

import { rankingConfig } from '../ranking.config';

interface RankingStaticHeaderProps {
  navigationData: NavigationData;
}

export const RankingStaticHeader = (props: RankingStaticHeaderProps) => {
  const { navigationData } = props;
  const { origin, locale, expertiseId } = navigationData;
  const { t } = useTranslation(rankingConfig.i18nNamespaces);
  const domainInfo = DomainInfo.getFromOrigin(origin);
  const getUrl = getUrlHelper(domainInfo, locale);

  const resource = getResourcesMenuData(t, getUrl, domainInfo, locale).find((item) => item.visible);
  const links = [
    { href: getUrl('client.explore'), label: t('common:navbar.menu.findAgencies_V2') },
    { href: getUrl('providers', {}), label: t('common:navbar.menu.getClients') },
    ...(resource != null ? [{ href: resource.href, label: t('common:navbar.menu.resources') }] : []),
  ];

  return (
    <header className="sticky top-0 z-50 border-b border-secondary-200 bg-white">
      <nav className="mx-auto flex h-16 w-full max-w-6xl items-center justify-between gap-4 px-4 md:px-6">
        <a href={domainInfo?.getLocalizedUrl(locale) ?? '/'} aria-label="Sortlist" className="flex items-center">
          <Logotype height={28} />
        </a>
        <ul className="hidden items-center gap-6 text-sm font-medium text-secondary-900 md:flex">
          {links.map((link) => (
            <li key={link.href}>
              <a href={link.href} className="hover:text-secondary-500">
                {link.label}
              </a>
            </li>
          ))}
        </ul>
        <Button
          as="a"
          href={getUrl('project.new', {
            autoload: 'true',
            expertiseId: expertiseId != null ? String(expertiseId) : undefined,
            ref: 'ranking-page',
          })}
          color="primary"
          variant="solid"
          size="md"
          className="max-w-[55vw] whitespace-normal text-center sm:max-w-none">
          {t('common:navbar.menu.postAProject')}
        </Button>
      </nav>
    </header>
  );
};
